import RebrandedHome from './RebrandedHome'

export default RebrandedHome
